
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    company: '',
    department: '',
    name: '',
    email: '',
    phone: '',
    machines: '',
    monthlyHours: '',
    setupFrequency: '',
    trialCuts: '',
    machineCharge: '',
    defectCost: '',
    interest: 'ショールームへ見学'
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/submit/zoller-diagnosis', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          company: '',
          department: '',
          name: '',
          email: '',
          phone: '',
          machines: '',
          monthlyHours: '',
          setupFrequency: '',
          trialCuts: '',
          machineCharge: '',
          defectCost: '',
          interest: 'デモ'
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            資料＆オファー
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <i className="ri-file-text-line text-3xl text-yellow-600 mb-4"></i>
              <h3 className="font-bold text-gray-900 mb-2">事例3社まとめPDF</h3>
              <p className="text-sm text-gray-600">K鉄工所様／五和工業様／ファイブ・ストレート様</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <i className="ri-calculator-line text-3xl text-yellow-600 mb-4"></i>
              <h3 className="font-bold text-gray-900 mb-2">貴社専用ROIレポート</h3>
              <p className="text-sm text-gray-600">現状値を入力→数日内に提出</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <i className="ri-price-tag-3-line text-3xl text-yellow-600 mb-4"></i>
              <h3 className="font-bold text-gray-900 mb-2">機種比較＆価格表</h3>
              <p className="text-sm text-gray-600">venturion / smile / オプション</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white p-8 rounded-xl shadow-lg">
          <form id="zoller-form" data-readdy-form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  会社名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  部署・役職
                </label>
                <input
                  type="text"
                  name="department"
                  value={formData.department}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  ご担当者名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  メールアドレス <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  電話番号
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  工作機台数
                </label>
                <input
                  type="number"
                  name="machines"
                  value={formData.machines}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  月稼働（h/台）
                </label>
                <input
                  type="number"
                  name="monthlyHours"
                  value={formData.monthlyHours}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  仕上げボーリング段取り回数（週当たり）
                </label>
                <input
                  type="number"
                  name="setupFrequency"
                  value={formData.setupFrequency}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  1回の段取りでの試し削り回数
                </label>
                <input
                  type="number"
                  name="trialCuts"
                  value={formData.trialCuts}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  機械チャージ（円/h）
                </label>
                <input
                  type="number"
                  name="machineCharge"
                  value={formData.machineCharge}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  不良費（月）
                </label>
                <input
                  type="number"
                  name="defectCost"
                  value={formData.defectCost}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  ご関心 <span className="text-red-500">*</span>
                </label>
                <select
                  name="interest"
                  value={formData.interest}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                >
                  <option value="ショールームへ見学">ショールームへ見学</option>
                  <option value="お客様先に実機を持ち込んでデモ">お客様先に実機を持ち込んでデモ</option>
                  <option value="ROI診断">ROI診断</option>
                  <option value="見積">見積</option>
                  <option value="資料のみ">資料のみ</option>
                </select>
              </div>
            </div>
            
            {submitStatus === 'success' && (
              <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                お申し込みありがとうございます。担当者より3営業日以内にご連絡いたします。
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                送信に失敗しました。お手数ですが、もう一度お試しください。
              </div>
            )}
            
            <div className="text-center">
              <Button 
                type="submit" 
                variant="primary" 
                size="lg"
                className={isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line mr-2 animate-spin"></i>
                    送信中...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line mr-2"></i>
                    無料で受け取る
                  </>
                )}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
